module.exports = __webpack_public_path__ + "static/media/coffe-and-spices.4cb4bea9.jpg";